import { Injectable, OnInit } from '@angular/core'
//==========多言語化対応追加import=========
import { TranslateService } from '@ngx-translate/core';
import { UserSettingsService, ICultureInfo, CultureService} from '@ar2/common';
import { ENV } from '../config/config.dev'
import { SystemMessageResourceBundleEn } from '../messages-resource-module-en';

/**
 * システムメッセージ取得サービス
 * @author nabla2.metamodel.generator
 */
@Injectable()
export class SystemMessageService implements OnInit {

  constructor(
  //==========多言語化対応DI=========
    private translate: TranslateService,
    private userSettings:UserSettingsService,
    private culture: CultureService,
  ) {}

  ngOnInit(): void {
    this.initializes()
  }

  textOf(messageId: string, params: any): string {
    const code = this.translate.currentLang
    const messageResource = this.getMessageResource(code)
    const message = messageResource[messageId];
    if(Array.isArray(params)) {
      return SystemMessageService.formatByArray(message, params)
    } else {
      return SystemMessageService.formatByObject(message, params)
    }
  }

  defaultLocaleTextOf(messageId: string, params: any): string {
    const message = SystemMessageResourceBundleEn[messageId];
    if(Array.isArray(params)) {
      return SystemMessageService.formatByArray(message, params)
    } else {
      return SystemMessageService.formatByObject(message, params)
    }
  }

  private static formatByArray(msg: string, args: any[]): string {
    return msg.replace(/\{(\d+)\}/g, (match, p1) => {
      return args[p1];
    });
  }

  private static formatByObject(msg: string, obj: any): string {
    return msg.replace(/\{(\w+)\}/g, (match, p1) => {
      return obj[p1];
    });
  }

  private initializes(): void {
    this.initializeTranslate()
    this.loadUserSettings()
  }

  private initializeTranslate(): void {
    const langs = ENV.getCultureCodes();
    this.translate.addLangs(langs);

    const defaultIndex = langs.indexOf('en-US');
    if (defaultIndex > -1) {
      this.translate.setDefaultLang('en-US');
      this.translate.use('en-US');
    } else {
      this.translate.setDefaultLang(langs[0]);
      this.translate.use(langs[0]);
    }
  }

  private loadUserSettings(): void {
    const langs = ENV.getCultureCodes();

    const userSettings = this.userSettings.getSettings();
    if (userSettings) {
      if (userSettings.language) {
        const langIndex = langs.indexOf(userSettings.language);
        if (langIndex > -1) {
          this.translate.use(langs[langIndex]);
        }
      }
    }
  }

  private getMessageResource(code: string): any {
    if (code.startsWith('en') ) return SystemMessageResourceBundleEn
    return SystemMessageResourceBundleEn
  }
}


// WEBPACK FOOTER //
// ./src/services/system-message.service.ts